import React, { useState, useEffect } from 'react';
import cogoToast from 'cogo-toast'
import { Field as Fieldmik, Form as Fomiker, withFormik } from 'formik'
import { Button, Container, Divider, Dropdown, Form as FormUi, Header, Segment } from 'semantic-ui-react'
import * as yup from 'yup'
import { MyCheckBox, MyNormalInput, MyTextArea } from '../../apiInputComponent/myInput'
import putAxios from '../../axiosComponent/put'
import AddTitleBar from '../../titleBar/add_titleBar'
import Axios from 'axios';
import { AllRegex } from '../../../utils/validation';
import {
	FIELD_IS_REQUIRED, INVALID_BANK_ACC_NUMBER,
	INVALID_BANK_IFSC, INVALID_GST_NO, INVALID_NAME,
	INVALID_NUMBER, INVALID_PINCODE, INVALID_SPACE
} from '../../../config/const';

const AddVendor = ({ errors, touched, values, handleSubmit, isSubmitting, setFieldValue }) => {
	const [vendorCategoryList, setVendorCategoryList] = useState([]);

	useEffect(() => {
		const userId = localStorage.getItem('userId');
		const token = localStorage.getItem('apiToken');
		const customerNo = Number(localStorage.getItem('customerNo'));

		Axios.get(`${process.env.REACT_APP_BASE_URL}/masters/vendorType/0`, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': token
			},
			params: {
				customerNo: customerNo,
				userId: userId
			}
		}).then((response => {
			let options = [];
			response.data.resultSet.map((object, index) => {
				let temp = {}
				temp.key = object.vendorTypeId
				temp.text = object.vendorType
				temp.value = object.vendorTypeId
				temp.id = object.vendorTypeId
				return options[index] = temp
			})
			setVendorCategoryList(options);
		}))
			.catch(error => {
				console.log("🚀 ~ file: insertVendor.js ~ line 42 ~ useEffect ~ error", error)
			})
	}, []);

	return (
		<>
			<AddTitleBar Title="New Vendor" LinkName="/vendor" />
			<Container fluid className="m-2">
				<Fomiker>
					<Segment>
						<div className="ui form tiny">
							<Header color="blue" size="tiny" className="labelName p-bold-500">Basic Details</Header>
							<FormUi.Group inline={touched.vendorName && errors.vendorName ? false : true}>
								<FormUi.Field width="4">
									<label className="labelName">Vendor Code</label>
								</FormUi.Field>
								<FormUi.Field width={3}>
									<Fieldmik component={MyNormalInput} name="vendorCode" placeholder="Code" />
									{touched.vendorCode && errors.vendorCode ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vendorCode}</div> : ''}
								</FormUi.Field>
								<FormUi.Field width="1" />
								<FormUi.Field width="3">
									<label className="labelName">Vendor Company Name *</label>
								</FormUi.Field>
								<FormUi.Field width={3} error={values.vendorName ? false : true}>
									<Fieldmik component={MyNormalInput} name="vendorName" placeholder="Name" />
									{touched.vendorName && errors.vendorName ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vendorName}</div> : ''}
								</FormUi.Field>
							</FormUi.Group>
							<FormUi.Group inline>
								<FormUi.Field width="4">
									<label className="labelName">Contact Person Name *</label>
								</FormUi.Field>
								<FormUi.Field width={3} error={values.contactPersonFirstName ? false : true}>
									<Fieldmik component={MyNormalInput} name="contactPersonFirstName" placeholder="Name" />
									{/* <Fieldmik component={MyNormalInput} name="contactPersonLastName" placeholder="Last Name" /> */}
									{touched.contactPersonFirstName && errors.contactPersonFirstName ? <div className="w3-text-red w3-tiny p-bold-600">{errors.contactPersonFirstName}</div> : ''}
									{/* {touched.contactPersonLastName && errors.contactPersonLastName ? <div className="w3-text-red w3-tiny p-bold-600">{errors.contactPersonLastName}</div> : ''} */}
								</FormUi.Field>
								<FormUi.Field width="1" />

								<FormUi.Field width="3">
									<label className="labelName">Vendor Mobile Number *</label>
								</FormUi.Field>
								<FormUi.Field width={3} error={values.phone ? false : true}>
									<Fieldmik maxLength="10" component={MyNormalInput} name="phone" placeholder="Mobile" />
									<Fieldmik component={MyCheckBox} name="isSMSAlert" />
									{touched.phone && errors.phone ? <div className="w3-text-red w3-tiny p-bold-600">{errors.phone}</div> : ''}
								</FormUi.Field>
							</FormUi.Group>

							{/* <FormUi.Group inline>
                                {/* <FormUi.Field width="4">
                                    <label className="labelName">Vendor Email Id *</label>
                                </FormUi.Field>
                                <FormUi.Field width={3} error={values.email ? false : true}>
                                    <Fieldmik component={MyNormalInput} name="email" placeholder="Email" />
                                    <Fieldmik component={MyCheckBox} name="isEmailAlert" />
                                    {touched.email && errors.email ? <div className="w3-text-red w3-tiny p-bold-600">{errors.email}</div> : ''}
                                </FormUi.Field> */}
							{/* <FormUi.Field width="1" /> 
                                <FormUi.Field width="3">
                                    <label className="labelName">Vendor Mobile Number *</label>
                                </FormUi.Field>
                                 <FormUi.Field width="1" />
                                <FormUi.Field width={3} error={values.phone ? false : true}>
                                    <Fieldmik maxLength="10" component={MyNormalInput} name="phone" placeholder="Mobile" />
                                    <Fieldmik component={MyCheckBox} name="isSMSAlert" />
                                    {touched.phone && errors.phone ? <div className="w3-text-red w3-tiny p-bold-600">{errors.phone}</div> : ''}
                                </FormUi.Field>
                            </FormUi.Group> */}
							<Divider />
							<FormUi.Group inline>
								<FormUi.Field width="4">
									<label className="labelName">Company Address</label>
								</FormUi.Field>
								<FormUi.Field width={3}>
									<Fieldmik width={16} className="p-0" component={MyTextArea} name="address" />
									{touched.address && errors.address ? <div className="w3-text-red w3-tiny p-bold-600">{errors.address}</div> : ''}
								</FormUi.Field>
								<FormUi.Field width="1" />
								{/* <FormUi.Field width="3">
                                    <label className="labelName">City</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik style={{ width: '300px' }} component={MyCity} name="cityId" placeholder="City" />
                                    {touched.cityId && errors.cityId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.cityId}</div> : ''}
                                </FormUi.Field> */}
							</FormUi.Group>
							<FormUi.Group inline>
								{/* <FormUi.Field width="4">
                                    <label className="labelName">State</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik style={{ width: '300px' }} component={MyState} name="stateId" placeholder="State" />
                                    {touched.stateId && errors.stateId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.stateId}</div> : ''}
                                </FormUi.Field> */}
								{/* <FormUi.Field width="1" /> */}
								{/* <FormUi.Field width="3">
                                    <label className="labelName">Country</label>
                                </FormUi.Field>
                                   <FormUi.Field width="1" />
                                <FormUi.Field width={3}>
                                    <Fieldmik style={{ width: '300px' }} component={MyCountry} name="countryId" placeholder="Country" />
                                    {touched.countryId && errors.countryId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.countryId}</div> : ''}
                                </FormUi.Field> */}
							</FormUi.Group>
							<FormUi.Group inline>
								<FormUi.Field width="2">
									<label className="labelName">Pincode</label>
								</FormUi.Field>
								<FormUi.Field width={1} />
								<FormUi.Field width={3}>
									<Fieldmik maxLength="6" component={MyNormalInput} name="pincode" />
									{touched.pincode && errors.pincode ? <div className="w3-text-red w3-tiny p-bold-600">{errors.pincode}</div> : ''}
								</FormUi.Field>
								<FormUi.Field width="2">
									<label className="labelName">Vendor Type</label>
								</FormUi.Field>
								<FormUi.Field width={1} />
								<FormUi.Field width={3}>
									<Dropdown
										name="vendorTypeId"
										clearable
										style={{ width: "100%", fontWeight: "normal" }}
										selection
										placeholder="Please select Vendor Type"
										value={values.vendorTypeId}
										options={vendorCategoryList}
										onChange={(name, data) => {
											setFieldValue("vendorTypeId", data.value);
										}}
									/>
								</FormUi.Field>
							</FormUi.Group>

							<FormUi.Group inline>

								{/* <FormUi.Field width="4">
                                    <label className="labelName">GST Number</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} name="gstNo" />
                                    <Fieldmik component={MyCheckBox} name="isGstNA" />
                                    {touched.gstNo && errors.gstNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.gstNo}</div> : ''}
                                </FormUi.Field>
                                <FormUi.Field width="1" /> */}
								{/* <FormUi.Field width="3">
                                    <label className="labelName">PAN Number</label>
                                </FormUi.Field>
                                <FormUi.Field width="1" />
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} name="panNo" />
                                    <Fieldmik component={MyCheckBox} name="isPanNA" />
                                    {touched.panNo && errors.panNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.panNo}</div> : ''}
                                </FormUi.Field> */}
							</FormUi.Group>
							{/* <Divider /> */}
							{/* <FormUi.Group>
                                <FormUi.Field width="4">
                                    <label className="labelName">Credit Period</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} className="inputLabel" label={{ basic: true, content: 'Days' }} labelPosition='right' name="creditPeriod" />
                                </FormUi.Field>
                            </FormUi.Group>
                            <Divider />
                            <FormUi.Group inline>
                                <FormUi.Field width="4">
                                    <label className="labelName">Bank Name</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} name="bankName" />
                                </FormUi.Field>
                                <FormUi.Field width="1" />
                                <FormUi.Field width="3">
                                    <label className="labelName">Account Number</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik maxLength="20" component={MyNormalInput} name="accountNo" />
                                </FormUi.Field>
                                {touched.accountNo && errors.accountNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.accountNo}</div> : ''}

                            </FormUi.Group>
                            <FormUi.Group inline>
                                <FormUi.Field width="4">
                                    <label className="labelName">Account Holder Name</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik component={MyNormalInput} name="accountName" />
                                </FormUi.Field>
                                <FormUi.Field width="1" />
                                <FormUi.Field width="3">
                                    <label className="labelName">IFSC Code</label>
                                </FormUi.Field>
                                <FormUi.Field width={3}>
                                    <Fieldmik maxLength="11" component={MyNormalInput} name="ifscCode" />
                                </FormUi.Field>
                                {touched.ifscCode && errors.ifscCode ? <div className="w3-text-red w3-tiny p-bold-600">{errors.ifscCode}</div> : ''}

                            </FormUi.Group> */}
						</div>

					</Segment>
					<center><Button onClick={handleSubmit} size="mini" primary type="submit">Submit</Button></center>
				</Fomiker>
			</Container>
		</>
	)
}

const FormikAddVendor = withFormik({
	mapPropsToValues({ vendorCode, vendorName, firstName, lastName, vendorTypeId, email, phone, companyAddress, isSMSAlert,
		cityId, stateId, countryId, pincode, gstNo, panNo, communicationAddress, vendorCommState,
		isGstNA, isPanNA, creditPeriod, bankName, accountNo, accountName, isEmailAlert, ifscCode }) {
		return {
			vendorCode: vendorCode || '',
			vendorName: vendorName || '',
			contactPersonFirstName: firstName || '',
			contactPersonLastName: lastName || '',
			email: email || '',
			isEmailAlert: isEmailAlert || 0,
			phone: phone || '',
			isSMSAlert: isSMSAlert || 0,
			address: companyAddress || '',
			cityId: cityId || '',
			stateId: stateId || '',
			countryId: countryId || '',
			pincode: pincode || '',
			panNo: panNo || '',
			isGstNA: isGstNA || 0,
			isPanNA: isPanNA || 0,
			gstNo: gstNo || '',
			communicationAddress: communicationAddress || '',
			vendorCommState: vendorCommState || '',
			creditPeriod: creditPeriod || '',
			bankName: bankName || '',
			accountNo: accountNo || '',
			accountName: accountName || '',
			ifscCode: ifscCode || '',
			vendorTypeId: vendorTypeId || null,
		}
	},
	validationSchema: yup.object().shape({
		vendorName: yup.string().matches(AllRegex.noSPace, INVALID_SPACE).required(FIELD_IS_REQUIRED),
		contactPersonFirstName: yup.string().matches(AllRegex.Name, INVALID_NAME).required(FIELD_IS_REQUIRED),
		phone: yup.string().matches(AllRegex.phoneNo, INVALID_NUMBER).required(FIELD_IS_REQUIRED),
		address: yup.string().optional(),
		cityId: yup.string().optional(),
		stateId: yup.string().optional(),
		countryId: yup.string().optional(),
		pincode: yup.string().matches(AllRegex.Pincode, INVALID_PINCODE).optional(),
		gstNo: yup.string().matches(AllRegex.GSTIN, INVALID_GST_NO),
		creditPeriod: yup.string().matches(AllRegex.phoneNo, INVALID_NUMBER).optional(),
		accountNo: yup.string().matches(AllRegex.BankAccNumber, INVALID_BANK_ACC_NUMBER).optional(),
		ifscCode: yup.string().matches(AllRegex.BankIFSCcode, INVALID_BANK_IFSC).optional(),
		vendorTypeId: yup.string().optional(),
	}),

	handleSubmit(values, { setSubmitting }) {

		let extraData = {
			transporterCode: values.vendorCode.toUpperCase(),
			transporterName: values.vendorName,
			transporterContactPerson: values.contactPersonFirstName,
			contactPersonLastName: values.contactPersonLastName,
			vendorOwnershipType: values.vendorTypeId,
			transporterEmail: values.email,
			isEmailAlert: values.isEmailAlert || 0,
			transporterContactPersonNumber: values.phone,
			isSMSAlert: values.isSMSAlert || 0,
			companyAddress: values.address,
			communicationAddress: values.communicationAddress ? values.communicationAddress : values.address,
			cityId: values.cityId,
			stateId: values.stateId,
			countryId: values.countryId,
			companyPincode: values.pincode,
			companyPan: values.panNo,
			isGstNA: values.isGstNA || 0,
			isPanNA: values.isPanNA || 0,
			gstNo: values.gstNo,
			// vendorCommCity: vendorCommCity,
			// communicationAddress: vendorCommAddress,
			// vendorCommState: vendorCommState,
			// vendorCommCountry: vendorCommCountry,
			// vendorCommPin: vendorCommPin,
			// vendorCommGst: vendorCommGst,
			// vendorCommPan: vendorCommPan,
			creditPeriod: values.creditPeriod,
			bankName: values.bankName,
			accountNo: values.accountNo,
			accountName: values.accountName,
			ifscCode: values.ifscCode,
			vendorTypeId: values.vendorTypeId || 0
		}

		putAxios({
			url: 'masters/transporterMaster',
			createItems: extraData
		}).then((childData) => {
			if (childData.data.status === 200) {
				setSubmitting(false)
				cogoToast.success(childData.data.message)
				setInterval(() => {
					window.location.href = '/vendor'
				}, 500);

			} else if (childData.data.status == 204) {
				cogoToast.error(childData.data.message)
			}
			else {
				cogoToast.error(childData.data.message)
				setSubmitting(false)
			}
		}
		)
	}
})(AddVendor)

export default FormikAddVendor